import { getField, updateField } from '@/libs/vuexHelper';
import i18n from '@/locales';

export interface IForm {
    channel: string;
    name: string;
    audience: number;
    content: any[];
    begin_config: '0' | '1';
    begin_time: string;
    timezone: string;
    frequencyType: 'default' | 'customize';
    send_frequency: number[];
    send_count: number;
    contentType: 'template' | 'common',
    exclude_chat_user_ids?: string;
    advanced_query_type?: string;
    advanced_query?: string;
    emailTitle?: string; // 邮件群发中使用
    emailContent?: string; // 邮件群发中使用
    template_id?: string;
    template_type?: '0' | '1', // 邮件内容类型 0直接编辑、1使用模板
    email_attachments?: any[]; // 邮件附件
    variable_config?: { [key in string]: string }; // 变量
    regular_type: '0' | '1', // 发送类型 0-单次 1-循环
    regular_config?: string, // 循环发送配置 {"cycle_type": "weekly", "week_interval": 1, "days_of_week": [1,3,5,7], "times": [{"hour":14,"minute":30}]}
    finish_time?: string // 循环发送结束时间
}

const getInitPlanForm = (): IForm => {
    return {
        channel: '7',
        name: `${i18n.t('broadcast.planName')}-${Date.now()}`,
        audience: 0,
        content: [],
        begin_config: '0',
        begin_time: '',
        timezone: '',
        emailTitle: '',
        emailContent: '',
        template_id: '',
        template_type: '0',
        email_attachments: [],
        frequencyType: 'default',
        send_frequency: [3, 5],
        send_count: 1,
        contentType: 'template',
        regular_type: '0',
    };
};
interface IState {
    planForm: IForm;
}

export default {
    namespaced: true,
    state: {
        planForm: getInitPlanForm(),

        libraryItem: {},
    },
    getters: {
        getField,
    },
    mutations: {
        updateField,
        resetPlanForm(state: IState) {
            state.planForm = getInitPlanForm();
        },
        setLibraryItem(state: any, item: any) {
            state.libraryItem = item;
        },
    },
    actions: { },
};
